// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Apply the font to all elements */
* {
  font-family: "Montserrat", "Helvetica Neue", Arial, Helvetica, sans-serif;
  box-sizing: border-box; /* Include padding and border in element's total width and height */
}
/* Set default margin and padding to 0, and make body 100% height */
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden; /* Hide any overflowing content */
}
/* Sidebar styles */
.sidebar {
  height: 100vh; /* Use viewport height for full height */
  width: 35vh; /* Use percentage for width */
  background-color: #dbe3ef;
  padding: 20px; /* Add padding for spacing */
}
.apiCard {
  border-radius: 35px;
  padding-top: 20px;
  align-items: center;
}
.apiListScroll {
  overflow-y: scroll;
  max-height: 550vh;
  width: 30vh;
  height: 82vh;
}
.apiListScroll::-webkit-scrollbar {
  display: none;
}
.orderedList {
  margin: 0;
  padding: 1vh;
  list-style-type: none;
}
/* Main content styles */
.apiContent {
  width: 95%; /* Use the remaining width */
  height: 97%; /* Use viewport height for full height */
  min-height: 80vh;
  padding: 25px;
  box-sizing: border-box; /* Include padding and border in element's total width and height */
  border-radius: 3vh;
  margin-left: 3vh;
}
.apiContainer {
  width: 95%;
  height: auto;
  padding: 25px;
  box-sizing: border-box;
  border-radius: 35px;
  margin-top: 3vh;
  margin-left: 3vh;
}
.subApiListScroll {
  border-radius: 35px;
  width: 100%;

  background-color: #eef0f6;
  overflow-y: scroll;
  min-height: 55vh;
  height: auto;
}
.subApiListScroll::-webkit-scrollbar {
  display: none;
}
/* Responsive adjustments */
@media screen and (max-width: 768px) {
  /* For screens smaller than 768px */
  .sidebar {
    width: 100%; /* Full width for smaller screens */
    height: auto; /* Allow content to expand vertically */
  }
  .apiContent {
    width: 100%; /* Full width for smaller screens */
    height: auto; /* Allow content to expand vertically */
  }
}
.subApiCard {
  height: auto;
  min-height: 60vh;
  border-radius: 35px;
  width: 100%;
}
.subApiCardDesign {
  border-radius: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.subApiCardDesignLong {
  border-radius: 35px;
  display: flex;
  flex-direction: column;
}
.apiButton {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
}
.quickLookCard {
  width: 90%;
  height: 100%;
  background-color: #eef0f6;
  border-radius: 20px;
  margin-left: 6vh;
  margin-top: 2vh;
}
.quickLookCardFT {
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  width: 90%;
  height: 100%;
  background-color: #eef0f6;
  border-radius: 20px;
  margin-left: 6vh;
  margin-top: 2vh;
  min-height: 50px;
}
.codeCheckContainer {
  text-align: center;
  border-radius: 35px;
}
/* Button styles */
.statusButton,
.statusButtonOK,
.statusButtonNOK,
.genericButton {
  display: inline-block; /* Make buttons display inline */
  padding: 10px 20px; /* Add padding for button size */
  margin: 5px; /* Add margin for spacing between buttons */
  text-align: center; /* Center text */
  border-radius: 20px; /* Rounded corners */
  color: white; /* Text color */
}
.genericButton {
  background-color: #485785;
  color: white;
  padding: 5px 10px;
  border-radius: 15px;
  margin: 5px;
}
.sidebarButton {
  background-color: #485785; /* Sidebar button color */
  width: 170px;
  font-size: 13px;
  color: white;
  align-content: center;
}
.statusButton {
  background-color: #485785; /* Status button color */
  border: none; /* Remove border */
}
.statusButtonOK,
.statusButtonNOK {
  width: 200px; /* Status button width */
}
/* Hover styles */
.statusButton:hover,
.statusButtonOK:hover,
.statusButtonNOK:hover,
.sidebarButton:hover {
  color: white; /* Change text color on hover */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Add text shadow on hover */
}
/* Escalation Tool CSS */
.subApiCardDesignET {
  border-radius: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 1rem;
  box-sizing: border-box;
}
.subApiListScrollET {
  border-radius: 35px;
  width: 100%;
  background-color: #eef0f6;
  overflow-y: scroll;
  max-height: 400vh;
  height: 445px;
  padding: 1rem;
  box-sizing: border-box;
}
.subApiListScrollET::-webkit-scrollbar {
  display: none;
}
.subApiCardDesignETR {
  border-radius: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 65vh;
  margin-bottom: 2vh;
  box-sizing: border-box;
}
.subApiListScrollETR {
  width: 100%;
  height: 210px;
  background-color: #eef0f5;
  overflow-y: scroll;
  max-height: 400vh;
}
.subApiListScrollETR::-webkit-scrollbar {
  display: none;
}
/* Media queries for responsive design */
@media (max-width: 768px) {
  .subApiListScrollQR,
  .subApiListScrollET,
  .subApiListScrollETR {
    height: auto;
    max-height: 50vh;
  }
}
.apiButtonGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1px;
  row-gap: 1px;
  padding: 0px;
  overflow: hidden;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
}
.apiButtonGrid::-webkit-scrollbar {
  display: none;
}
.apiButtonItem {
  list-style: none;
  border-radius: 25px;
  margin: 0;
}

/* Media queries for responsive design */
@media (max-width: 1024px) {
  .apiButtonGrid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 8px;
  }
}

@media (max-width: 768px) {
  .apiButtonGrid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .apiButtonGrid {
    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
    gap: 5px;
  }
}

/* Additional styling for small screens */
@media (max-width: 320px) {
  .apiButtonGrid {
    grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));
    gap: 4px;
  }
}

/* EscalationSlackbot */
.subApiCardDesignESB {
  border-radius: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 49vh;
  margin-bottom: 2vh;
  box-sizing: border-box;
}
.carousel-control-prev-icon,
.carousel-control-next-icon,
.carousel-indicators .active {
  filter: invert(1);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;EACE,yEAAyE;EACzE,sBAAsB,EAAE,mEAAmE;AAC7F;AACA,mEAAmE;AACnE;;EAEE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE,iCAAiC;AACrD;AACA,mBAAmB;AACnB;EACE,aAAa,EAAE,wCAAwC;EACvD,WAAW,EAAE,6BAA6B;EAC1C,yBAAyB;EACzB,aAAa,EAAE,4BAA4B;AAC7C;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;EACT,YAAY;EACZ,qBAAqB;AACvB;AACA,wBAAwB;AACxB;EACE,UAAU,EAAE,4BAA4B;EACxC,WAAW,EAAE,wCAAwC;EACrD,gBAAgB;EAChB,aAAa;EACb,sBAAsB,EAAE,mEAAmE;EAC3F,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;;EAEX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA,2BAA2B;AAC3B;EACE,mCAAmC;EACnC;IACE,WAAW,EAAE,mCAAmC;IAChD,YAAY,EAAE,uCAAuC;EACvD;EACA;IACE,WAAW,EAAE,mCAAmC;IAChD,YAAY,EAAE,uCAAuC;EACvD;AACF;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,SAAS;AACX;AACA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA,kBAAkB;AAClB;;;;EAIE,qBAAqB,EAAE,gCAAgC;EACvD,kBAAkB,EAAE,gCAAgC;EACpD,WAAW,EAAE,2CAA2C;EACxD,kBAAkB,EAAE,gBAAgB;EACpC,mBAAmB,EAAE,oBAAoB;EACzC,YAAY,EAAE,eAAe;AAC/B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,YAAY,EAAE,kBAAkB;AAClC;AACA;;EAEE,YAAY,EAAE,wBAAwB;AACxC;AACA,iBAAiB;AACjB;;;;EAIE,YAAY,EAAE,+BAA+B;EAC7C,2CAA2C,EAAE,6BAA6B;AAC5E;AACA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA,wCAAwC;AACxC;EACE;;;IAGE,YAAY;IACZ,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE;IACE,4DAA4D;IAC5D,QAAQ;EACV;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,QAAQ;EACV;AACF;;AAEA;EACE;IACE,2DAA2D;IAC3D,QAAQ;EACV;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,2DAA2D;IAC3D,QAAQ;EACV;AACF;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;;EAGE,iBAAiB;AACnB","sourcesContent":["/* Apply the font to all elements */\n* {\n  font-family: \"Montserrat\", \"Helvetica Neue\", Arial, Helvetica, sans-serif;\n  box-sizing: border-box; /* Include padding and border in element's total width and height */\n}\n/* Set default margin and padding to 0, and make body 100% height */\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; /* Hide any overflowing content */\n}\n/* Sidebar styles */\n.sidebar {\n  height: 100vh; /* Use viewport height for full height */\n  width: 35vh; /* Use percentage for width */\n  background-color: #dbe3ef;\n  padding: 20px; /* Add padding for spacing */\n}\n.apiCard {\n  border-radius: 35px;\n  padding-top: 20px;\n  align-items: center;\n}\n.apiListScroll {\n  overflow-y: scroll;\n  max-height: 550vh;\n  width: 30vh;\n  height: 82vh;\n}\n.apiListScroll::-webkit-scrollbar {\n  display: none;\n}\n.orderedList {\n  margin: 0;\n  padding: 1vh;\n  list-style-type: none;\n}\n/* Main content styles */\n.apiContent {\n  width: 95%; /* Use the remaining width */\n  height: 97%; /* Use viewport height for full height */\n  min-height: 80vh;\n  padding: 25px;\n  box-sizing: border-box; /* Include padding and border in element's total width and height */\n  border-radius: 3vh;\n  margin-left: 3vh;\n}\n.apiContainer {\n  width: 95%;\n  height: auto;\n  padding: 25px;\n  box-sizing: border-box;\n  border-radius: 35px;\n  margin-top: 3vh;\n  margin-left: 3vh;\n}\n.subApiListScroll {\n  border-radius: 35px;\n  width: 100%;\n\n  background-color: #eef0f6;\n  overflow-y: scroll;\n  min-height: 55vh;\n  height: auto;\n}\n.subApiListScroll::-webkit-scrollbar {\n  display: none;\n}\n/* Responsive adjustments */\n@media screen and (max-width: 768px) {\n  /* For screens smaller than 768px */\n  .sidebar {\n    width: 100%; /* Full width for smaller screens */\n    height: auto; /* Allow content to expand vertically */\n  }\n  .apiContent {\n    width: 100%; /* Full width for smaller screens */\n    height: auto; /* Allow content to expand vertically */\n  }\n}\n.subApiCard {\n  height: auto;\n  min-height: 60vh;\n  border-radius: 35px;\n  width: 100%;\n}\n.subApiCardDesign {\n  border-radius: 35px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.subApiCardDesignLong {\n  border-radius: 35px;\n  display: flex;\n  flex-direction: column;\n}\n.apiButton {\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n.quickLookCard {\n  width: 90%;\n  height: 100%;\n  background-color: #eef0f6;\n  border-radius: 20px;\n  margin-left: 6vh;\n  margin-top: 2vh;\n}\n.quickLookCardFT {\n  display: flex;\n  /* flex-direction: column; */\n  justify-content: center;\n  align-items: center;\n  width: 90%;\n  height: 100%;\n  background-color: #eef0f6;\n  border-radius: 20px;\n  margin-left: 6vh;\n  margin-top: 2vh;\n  min-height: 50px;\n}\n.codeCheckContainer {\n  text-align: center;\n  border-radius: 35px;\n}\n/* Button styles */\n.statusButton,\n.statusButtonOK,\n.statusButtonNOK,\n.genericButton {\n  display: inline-block; /* Make buttons display inline */\n  padding: 10px 20px; /* Add padding for button size */\n  margin: 5px; /* Add margin for spacing between buttons */\n  text-align: center; /* Center text */\n  border-radius: 20px; /* Rounded corners */\n  color: white; /* Text color */\n}\n.genericButton {\n  background-color: #485785;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 15px;\n  margin: 5px;\n}\n.sidebarButton {\n  background-color: #485785; /* Sidebar button color */\n  width: 170px;\n  font-size: 13px;\n  color: white;\n  align-content: center;\n}\n.statusButton {\n  background-color: #485785; /* Status button color */\n  border: none; /* Remove border */\n}\n.statusButtonOK,\n.statusButtonNOK {\n  width: 200px; /* Status button width */\n}\n/* Hover styles */\n.statusButton:hover,\n.statusButtonOK:hover,\n.statusButtonNOK:hover,\n.sidebarButton:hover {\n  color: white; /* Change text color on hover */\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); /* Add text shadow on hover */\n}\n/* Escalation Tool CSS */\n.subApiCardDesignET {\n  border-radius: 35px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n.subApiListScrollET {\n  border-radius: 35px;\n  width: 100%;\n  background-color: #eef0f6;\n  overflow-y: scroll;\n  max-height: 400vh;\n  height: 445px;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n.subApiListScrollET::-webkit-scrollbar {\n  display: none;\n}\n.subApiCardDesignETR {\n  border-radius: 35px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  max-width: 65vh;\n  margin-bottom: 2vh;\n  box-sizing: border-box;\n}\n.subApiListScrollETR {\n  width: 100%;\n  height: 210px;\n  background-color: #eef0f5;\n  overflow-y: scroll;\n  max-height: 400vh;\n}\n.subApiListScrollETR::-webkit-scrollbar {\n  display: none;\n}\n/* Media queries for responsive design */\n@media (max-width: 768px) {\n  .subApiListScrollQR,\n  .subApiListScrollET,\n  .subApiListScrollETR {\n    height: auto;\n    max-height: 50vh;\n  }\n}\n.apiButtonGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  column-gap: 1px;\n  row-gap: 1px;\n  padding: 0px;\n  overflow: hidden;\n  overflow-y: scroll;\n  width: 100%;\n  height: 100%;\n}\n.apiButtonGrid::-webkit-scrollbar {\n  display: none;\n}\n.apiButtonItem {\n  list-style: none;\n  border-radius: 25px;\n  margin: 0;\n}\n\n/* Media queries for responsive design */\n@media (max-width: 1024px) {\n  .apiButtonGrid {\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 8px;\n  }\n}\n\n@media (max-width: 768px) {\n  .apiButtonGrid {\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n    gap: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .apiButtonGrid {\n    grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));\n    gap: 5px;\n  }\n}\n\n/* Additional styling for small screens */\n@media (max-width: 320px) {\n  .apiButtonGrid {\n    grid-template-columns: repeat(auto-fill, minmax(50px, 1fr));\n    gap: 4px;\n  }\n}\n\n/* EscalationSlackbot */\n.subApiCardDesignESB {\n  border-radius: 35px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  max-width: 49vh;\n  margin-bottom: 2vh;\n  box-sizing: border-box;\n}\n.carousel-control-prev-icon,\n.carousel-control-next-icon,\n.carousel-indicators .active {\n  filter: invert(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
